import apiClient from "@/lib/api/api-client";
import { env } from "@/config/env";

export interface ForgotPasswordRequest {
  email: string;
}

export interface ForgotPasswordResponse {
  message: string;
}

export async function requestPasswordReset(payload: ForgotPasswordRequest) {
  const { data } = await apiClient.post<ForgotPasswordResponse>(
    env.authForgotPasswordPath,
    payload,
  );
  return data;
}
